import { render, staticRenderFns } from "./zen_what_is.vue?vue&type=template&id=1972c7fb&scoped=true&"
import script from "./zen_what_is.vue?vue&type=script&lang=js&"
export * from "./zen_what_is.vue?vue&type=script&lang=js&"
import style0 from "./zen_what_is.vue?vue&type=style&index=0&id=1972c7fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1972c7fb",
  null
  
)

export default component.exports